export default __webpack_public_path__ + "assets/images/60bebecd8d4c5d2371b562a63469682c.jpg";